import { Injectable } from '@angular/core';
import { url } from './bodyAll';
import { HttpClient, HttpHeaders } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class DataService {
 
  private data = [];
  constructor(
    private http: HttpClient,
  ) { }
 
  setData(id, data) {
    this.data[id] = data;
  }
  getData(id) {
    return this.data[id];
  }
  /**
  *  OBTNER DATA DE BARTER PAY
  */
  public getDataBarterPagos() {
    let seq = this.http.get(`${url}${'barterpay'}`, this.header_config()); 
    return seq;
  }

  public header_config (){
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type':  'application/json'
      })
    };

    return httpOptions;
  };

}